import { PluggableEventProcedureForm } from "./EventProcedureForm";
import EventProcedureSummary from "./EventProcedureSummary";
const eventProceduresBindings = {
  "views.components.eventProcedureForm": [
    {
      component: PluggableEventProcedureForm,
      key: "eventProcedureForm"
    }
  ],
  "views.components.eventProcedureSummary": [
    {
      component: EventProcedureSummary,
      key: "eventProcedureSummary"
    }
  ]
};
export default eventProceduresBindings;
